import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ff71710"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flow" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全流程成本管理", -1 /* HOISTED */))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "保障云资源利用率最大化", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _hoisted_3,
          (_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("，")
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock("br", _hoisted_4)),
          _hoisted_5
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_tabs, {
        activeKey: $data.tab.active,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => (($data.tab.active) = $event)),
        tabBarGutter: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.LG)?150:20,
        centered: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tab.list, (item, index) => {
            return (_openBlock(), _createBlock(_component_a_tab_pane, {
              key: index+1,
              tab: item.title
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, {
                  class: _normalizeClass({tab_show:$data.tab.show===index+1})
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: 24,
                      lg: 10,
                      order: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.LG)?1:2
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["item", `i_${index+1}`])
                        }, [
                          (item.title)
                            ? (_openBlock(), _createBlock(_component_a_typography_title, {
                                key: 0,
                                level: 5
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            : _createCommentVNode("v-if", true),
                          (item.sub)
                            ? (_openBlock(), _createBlock(_component_a_typography_title, {
                                key: 1,
                                level: 5
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.sub), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            : _createCommentVNode("v-if", true),
                          (item.text)
                            ? (_openBlock(), _createBlock(_component_a_typography_paragraph, { key: 2 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.text), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" <a-space :size=\"$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'\">\n                  <a-button type=\"link\" class=\"button_1\"\n                            @click=\"$RQ.GoGSS()\">\n                    免费试用\n                  </a-button>\n                </a-space> ")
                        ], 2 /* CLASS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["order"]),
                    _createVNode(_component_a_col, {
                      xs: 24,
                      lg: {offset:2,span:12},
                      order: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.LG)?2:1
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["media", `m_${index+1}`])
                        }, null, 2 /* CLASS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["order"])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"])
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["tab"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["activeKey", "tabBarGutter"])
    ])
  ]))
}